import angular from "angular"
import "../edition/edition"
import "front-end-web-commons"
import "./product.less"


export default angular.module("productModule", ["editionModule"])